import IPbiDashboard from "../models/IPbiDashboard";
import { fetchSecureData } from "../utils";

export const saveUpdatedDashboard = async (
  accessToken: string,
  dashboard: IPbiDashboard
) => {
  const payload = {
    id: dashboard.id,
    name: dashboard.name,
    // tslint:disable-next-line:object-literal-sort-keys
    displayName: dashboard.displayName,
    groupId: dashboard.groupId,
    reportId: dashboard.reportId,
    dashboardViewerVersion: dashboard.dashboardViewerVersion,
    isEnabled: dashboard.isEnabled
  };
  try {
    const data = await fetchSecureData(
      "PUT",
      `/api/PbiDashboard/Edit`,
      accessToken,
      payload
    );
    const result = ((await data.json()) as any).value as IPbiDashboard;
    // tslint:disable-next-line:no-console
    return result;
  } catch (err) {
    // tslint:disable-next-line:no-console
    console.log(`Fetch error for /api/PbiDashboard/Edit`, err);
  }
  return {} as IPbiDashboard;
};

export default saveUpdatedDashboard;
